import React from 'react'
import { addPartsToScraperSystem } from '../../utils/parts-scrape/api-calls';

export default function ScrapePartButton({loadingScrapeSubmit, setLoadingScrapeSubmit, setShowNotification, currentUser, partName}) {
    const addPartToScrapeSystem = async () => {
        try {
            setLoadingScrapeSubmit(true);
            await addPartsToScraperSystem(currentUser, [partName], false, false);
            setShowNotification({
                shown: true,
                status: 'success',
                title: 'Part Successfully Added.',
                message:
                    `${partName} has been added to the scrape queue successfully.`,
            });
        } catch (error) {
            setShowNotification({
                shown: true,
                status: 'error',
                title: 'Error adding part to the scrape system.',
                message:
                    'An error has occured adding part to the scrape system. Please try again and if the error persists contact your manager.',
            });
        } finally {
            setLoadingScrapeSubmit(false);
        }
    };

  return (
    <button
        disabled={loadingScrapeSubmit}
        onClick={() => addPartToScrapeSystem()}
        className='px-4 py-2 font-normal text-white rounded-md bg-blue-primary whitespace-nowrap h-full'
    >
        {loadingScrapeSubmit ? 'Submitting...' : 'Scrape Part'}
    </button>
  )
}
